import React from 'react'

export default function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 24" {...props}>
      <path
        fill="var(--svg-color-main, black)"
        fillRule="evenodd"
        d="M12.644 2.757a1 1 0 0 1 .97-.757h2.72v2l3.727.932a3 3 0 0 1 2.273 2.91V10c0 1.652 0 2.708-.317 3.34a3 3 0 0 1-1.343 1.344c-.633.316-1.459.316-3.11.316H7.104c-1.652 0-2.795 0-3.428-.316-.581-.29-1.343-1.184-1.343-2.684V8h7.439a2 2 0 0 0 1.94-1.515L12.334 4zm2.94 4.493a.75.75 0 0 0-.75.75v3.5a.75.75 0 0 0 1.5 0V8a.75.75 0 0 0-.75-.75m4 0a.75.75 0 0 0-.75.75v3.5a.75.75 0 0 0 1.5 0V8a.75.75 0 0 0-.75-.75M5.334 22a3 3 0 1 0 0-6 3 3 0 0 0 0 6m7 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6m7 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
        clipRule="evenodd"
      ></path>
      <path
        fill="var(--svg-color-main, black)"
        d="M12.334 4h-5.23c-1.652 0-2.795 0-3.428.316-.581.29-1.343 1.165-1.343 2.684v1h7.439a2 2 0 0 0 1.94-1.515z"
        opacity="0.4"
      ></path>
    </svg>
  )
}
